<template>
  <div class="flex px-6 bg-white clearfix">
    <div
      v-if="supplier && supplier.hbt_flow_enabled"
      class="flex justify-between w-full items-center"
    >
      <div v-if="getSelectedRoomDetails.length" class="flex flex-col">
        <span class="fs-14 text-black-light-5"> Total price: </span>
        <h4 class="fs-20 font-medium">
          <span>
            <currency-context>
              <template v-slot="{ convert }">
                <span v-text="convert(getTotalBooking)"></span>
              </template>
            </currency-context>
          </span>
        </h4>
      </div>
      <div v-else class="flex flex-col">
        <div>
          <span class="font-medium fs-20">
            <currency-context>
              <template v-slot="{ convert }">
                <span v-text="convert(price)"></span>
              </template>
            </currency-context>
          </span>
          <span>/day</span>
        </div>
        <div>per person</div>
      </div>
      <button
        type="button"
        class="btn btn-primary input-tall float-right font-medium plan-trip-btn"
        :class="{ 'btn-outlined': getSelectedRoomDetails.length }"
        @click="onClick()"
      >
        {{ ctaText() }}
      </button>
    </div>
    <div v-else class="flex items-center w-full">
      <div class="flex-1 flex flex-col">
        <div>
          <offer-tag-list></offer-tag-list>
          <div>
            <span>from</span>
            <span class="font-medium fs-20">
              <currency-context>
                <template v-slot="{ convert }">
                  <span v-text="convert(price)"></span>
                </template>
              </currency-context>
            </span>
            <span>/night</span>
          </div>
        </div>
      </div>

      <button
        type="button"
        class="btn btn-primary input-tall float-right font-medium plan-trip-btn"
        @click="handleYourStayClicked"
      >
        Book now
      </button>
    </div>

    <zb-modal
      ref="widgetModal"
      :is-full-screen="true"
      :show-close-icon="false"
      content-class="resort-booking-widget"
    >
      <template #title="{ modal }">
        <div class="w-full">
          <div class="flex items-center container-sm py-6 justify-between">
            <div></div>

            <button type="button" class="fs-16" @click="modal.hide">
              <div class="flex items-center">
                <strong class="mr-3">Close</strong>
                <svg width="24" height="24">
                  <use xlink:href="/img/sprite.svg#ic_close"></use>
                </svg>
              </div>
            </button>
          </div>

          <hr class="border border-black-30 w-full" />
        </div>
      </template>

      <template #default="{ modal }">
        <slot name="modal-content" :closeModal="modal.hide"></slot>
      </template>
    </zb-modal>

    <zb-modal
      ref="infoModal"
      :is-full-screen="true"
      :show-close-icon="false"
      content-class="resort-booking-widget"
    >
      <template #title="{ modal }">
        <div class="w-full">
          <div class="flex items-center container-sm py-6 justify-between">
            <div></div>
            <button type="button" class="fs-16" @click="modal.hide">
              <div class="flex items-center">
                <strong class="mr-3">Close</strong>
                <svg width="24" height="24">
                  <use xlink:href="/img/sprite.svg#ic_close"></use>
                </svg>
              </div>
            </button>
          </div>
        </div>
      </template>

      <template #default="{ modal }">
        <div v-if="supplier" class="mt-4">
          <EnquiryDirectBookingWidget
            :resort-id="supplier.id"
            :resortImage="resortImage"
            :destinationSku="destinationSku"
          />
        </div>
      </template>
    </zb-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ServiceRoom from "./HummingbirdFlow/ServiceRoom";
import TrengoLink from "../core/TrengoLink";
import EnquiryDirectBookingWidget from "../core/Booking/EnquiryDirectBookingWidget.vue";

export default {
  components: {
    ServiceRoom,
    TrengoLink,
    EnquiryDirectBookingWidget,
  },
  props: ["price", "resortImage", "destinationSku"],
  data() {
    return {
      supplier: null,
    };
  },
  computed: {
    ...mapState(["bookingRooms"]),
    ...mapGetters([
      "getSelectedRoomDetails",
      "getTotalBooking",
      "hbtFlowEnabled",
    ]),
    unselectedGroups() {
      const selectedGroups = this.getSelectedRoomDetails.map((room) =>
        room.group.slice(5)
      );

      let results = [];
      for (let i = 1; i <= this.bookingRooms.length; i++) {
        if (!selectedGroups.includes(i.toString())) {
          results.push(i);
        }
      }
      return results;
    },
  },
  mounted() {
    window.fetchSupplierInfo(this.resortId).then((response) => {
      this.supplier = response.supplier;

      if (!response.supplier.hbt_flow_enabled) {
        window.dispatchEvent(new CustomEvent("init-bottom-nav"));
      }
    });
  },
  methods: {
    fixCountryName(name) {
      const correctedCountryNames = {
        Maldives: "the Maldives",
        Philippines: "the Philippines",
      };

      if (correctedCountryNames[name]) {
        return correctedCountryNames[name];
      }
      return name;
    },
    handleYourStayClicked() {
      if (this.supplier && this.supplier.hbt_flow_enabled) {
        this.$store.commit("setShowPriceDetailsModal", true);
      } else {
        this.$refs.widgetModal.show();
      }
    },
    ctaText() {
      if (!this.getSelectedRoomDetails.length) {
        return "Book now";
      } else if (
        this.getSelectedRoomDetails.length === this.bookingRooms.length
      ) {
        return "View summary";
      } else {
        return `Select room ${this.unselectedGroups[0]}`;
      }
    },
    onClick() {
      if (!this.getSelectedRoomDetails.length) {
        this.$refs.infoModal.show();
      }

      if (this.getSelectedRoomDetails.length === this.bookingRooms.length) {
        this.$store.commit("setShowPriceDetailsModal", true);
        return;
      }

      window.scrollToElement($(`.group-title[data-group-id="group-1"]`));
    },
    isMobile() {
      return window.matchMedia("only screen and (max-width: 600px)").matches;
    },
    handleChat(openChat) {
      this.$refs.infoModal.hide();
      openChat();
    },
  },
  watch: {
    supplier(value) {
      if (value && value.hbt_flow_enabled) {
        if (this.isMobile()) {
          pushUpTrengoChat(true);
        }
      }
    },
  },
};
</script>

<style scoped>
::v-deep .wrap-service {
  background-color: var(--blue-light-1);
}

.wrap-list {
  margin-left: 20px;
  list-style: disc;
}

@media only screen and (max-width: 1200px) {
  ::v-deep .zb-modal-scrollable-content {
    background: unset !important;
  }
}
</style>
